import styled from 'styled-components';
import { Box, Text } from 'pcln-design-system';
export const ListingCardWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "HotlListingCardstyles__ListingCardWrapper",
  componentId: "sc-zhwo4o-0"
})(["max-width:375px;overflow:hidden;padding-bottom:20px;cursor:pointer;"]);
export const Img = /*#__PURE__*/styled.img.withConfig({
  displayName: "HotlListingCardstyles__Img",
  componentId: "sc-zhwo4o-1"
})(["object-fit:cover;width:375px;height:153px;"]);
export const PriceCurrency = /*#__PURE__*/styled(Text.span).withConfig({
  displayName: "HotlListingCardstyles__PriceCurrency",
  componentId: "sc-zhwo4o-2"
})(["vertical-align:super;position:relative;top:-2px;margin-right:2px;"]);
export const PriceCurrencyStrikeThrough = /*#__PURE__*/styled(PriceCurrency).withConfig({
  displayName: "HotlListingCardstyles__PriceCurrencyStrikeThrough",
  componentId: "sc-zhwo4o-3"
})(["top:1px;"]);
export const TextStrikeThrough = /*#__PURE__*/styled(Text).withConfig({
  displayName: "HotlListingCardstyles__TextStrikeThrough",
  componentId: "sc-zhwo4o-4"
})(["& ::before{content:'';width:10%;position:absolute;right:0px;top:14px;border-bottom:1px solid rgb(79,111,143);transform:skewY(-13deg);}"]);